import { useApi } from '~reviews/Widget/components/api-provider/use-api';
import { FormSettings } from '~commons/components/review-form/types';
import { useFormSettings as useCommonFormSettings } from '~commons/hooks/use-form-settings';

export const useFormSettings = (requireEmail: boolean = false): FormSettings => {
  const { configuration } = useApi((state) => ({
    configuration: state.configuration,
    isCurrentMember: state.members.currentOwner.type === 'MEMBER',
  }));
  return useCommonFormSettings({
    configuration,
    contactSettings: {
      name: { enabled: true },
      email: { enabled: requireEmail },
    },
  });
};
